export default __webpack_public_path__ + "static/plexus-desktop-1-cc5649b7a8ac7ea382a3cdd1cfa67821.avif";